// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"502":"monaco","833":"yjs"}[chunkId] || chunkId) + "." + {"502":"f387046a","623":"4791910e","833":"baa2cba8"}[chunkId] + ".chunk.js";
};